/**
 * firstSteps.ts — клиент ручки «Первые шаги» проекта (WEB-3889):
 * `GET /projects/:projectId/first-steps`.
 *
 * Сервер отдаёт ключи шагов с отметками и два признака: «проект новый»
 * (`isNew`) и «посещения были» (`hasVisits`); `null` у признака — проверка
 * не ответила, а не «нет». Аналитика (WEB-3752 юнит 2, решения владельца
 * 24.10 п. 20, 39) берёт отсюда только `hasVisits`: `false` — пустая
 * аналитика вместо страницы.
 *
 * Тип ответа — псевдоним контракта (`generated/schema.ts`), своих объявлений
 * полей здесь нет: расхождение с сервером ловит компилятор. Отказ сервера
 * уходит той же ошибкой общего обработчика `api/client.ts`.
 */
import { api } from '@/api/client';
import type { components } from '@/api/generated/schema';

export type ProjectFirstSteps = components['schemas']['FirstStepsResponseDto'];

export const firstStepsApi = {
  forProject: async (projectId: string): Promise<ProjectFirstSteps> => {
    const res = await api.get<ProjectFirstSteps>(
      `/projects/${encodeURIComponent(projectId)}/first-steps`,
    );
    return res.data;
  },
};
